import styled from "styled-components"

export const Container = styled.div`
`;

export const Content = styled.div`
    
    h6 {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 144px;
        font-family: var(--font-body);
        font-style: normal;
        font-weight: 500;
        font-size: 20px;
        line-height: 24px;
        letter-spacing: 0.15px;
        color: var(--text-primary);

        .colorSpanPack {
            color: var(--action-primary-surface);
            margin-left: 3px;
            margin-right: 3px;
        }}

        .registration {
            display: flex;
            align-items: center;
            flex-direction: column;
            color: var(--text-secondary);
            font-family: var(--font-body);
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            line-height: 24px;
            letter-spacing: 0.15px;

               input {
                width: 375.7px;
                height: 5px;
                &:hover{
                    border: 1px solid var(--action-link);
                }} 

                div {
                    margin-top: 12px;
                }
            }

         .button {
                .buttonAdvance {
                    height: 53px;
                    width: 196px;
                    background: var(--action-accent-surface);
                    border-radius: 10px;
                    border: 0px;
                    margin-left: 38%;
                    margin-top: 5%;

                    color: var(--text-primary);
                    font-family: var(--font-body);
                    font-style: normal;
                    font-weight: 500;
                    font-size: 14px;
                    line-height: 16px;

                    letter-spacing: 1.25px;
                    text-transform: uppercase;
                }
            }

`